<template>
    <b-container class="m-auto error-404">
        <b-row>
            <b-col md="6" class="text-center text-md-right d-flex align-items-center">
                <div class="w-100 pr-md-3 mb-4 mb-md-0">
                    <img
                        src="../../../assets/logo-buybox.png"
                        alt="BUY.BOX"
                        class="logo"
                    >
                </div>
            </b-col>
            <b-col md="6" class="text-center text-md-left d-flex align-items-center">
                <div class="w-100 pl-md-3">
                    <div class="display-1">
                        403
                    </div>
                    <div class="h2">
                        {{ $t('pageForbidden.title') }}
                    </div>
                    <p>{{ $t('pageForbidden.text') }}</p>
                    <b-button variant="outline-secondary" :href="widgeterLink">
                        {{ $t('pageForbidden.widgeterLink') }}
                    </b-button>
                    <b-button variant="outline-secondary" :href="advertiserLink" class="ml-2">
                        {{ $t('pageForbidden.advertiserLink') }}
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>



<script>
    export default {
        name: 'PageForbidden',
        data() {
            return {
                widgeterLink: process.env.VUE_APP_WIDGETER_URL,
                advertiserLink: process.env.VUE_APP_ADVERTISER_URL,
            };
        },
    };
</script>



<style lang="scss" scoped>
    .logo {
        width: 30vw;
        max-width: 400px;
    }
</style>

